import SystemUtil from './SystemUtil'
import LibContext from 'config/Context';
const API = 'https://api.test.shantaijk.cn/api/'

// // 展示错误信息
// function toastErrorMsg(errorMsg) {
//   wx.showToast({
//     title: errorMsg,
//     icon: "none",
//     duration: 2000
//   })
// }

// export function request(uri, data) {
//   return new Promise((resolve, reject) => {
//     wx.request({
//       url: API + uri,
//       header: {
//         'content-type': 'application/json',
//         'X-MOBILE-VersionCode': 1,
//         'X-MOBILE-ApplicationId': 4,
//         'X-MOBILE-SourceAppId': 'com.cloudhis.capp',
//         'X-MOBILE-ApiSubscriptionKey': '9645a34367594d66ad699cae30a5b9a7',
//         'X-MOBILE-Token': LibContext.getInstance().tk
//       },
//       method: 'POST',
//       data,
//       dataType: 'custom',
//       success: result => {
//         const res = SystemUtil.json_parse(result.data)
//         if (res.success) {
//           resolve(res)
//         } else {
//           reject(result)
//         }
//       },
//       fail: () => {
//         toastErrorMsg('请求失败，请检查网络是否正常')
//       },
//       complete: () => {
//         wx.hideLoading()
//       }
//     })
//   })
// }

class DiabloService {

  // 展示错误信息
toastErrorMsg=(errorMsg)=> {
  wx.showToast({
    title: errorMsg,
    icon: "none",
    duration: 2000
  })
}

  request=(uri, data)=> {
    return new Promise((resolve, reject) => {
      wx.request({
        url: API + uri,
        header: {
          'content-type': 'application/json',
          'X-MOBILE-VersionCode': 1,
          'X-MOBILE-ApplicationId': 4,
          'X-MOBILE-SourceAppId': 'com.cloudhis.capp',
          'X-MOBILE-ApiSubscriptionKey': '9645a34367594d66ad699cae30a5b9a7',
          'X-MOBILE-Token': LibContext.getInstance().tk
        },
        method: 'POST',
        data,
        dataType: 'custom',
        success: result => {
          const res = SystemUtil.json_parse(result.data)
          if (res.success) {
            resolve(res)
          } else {
            reject(result)
          }
        },
        fail: () => {
          this.toastErrorMsg('请求失败，请检查网络是否正常')
        },
        complete: () => {
          wx.hideLoading()
        }
      })
    })
  }

  getPersonMessage(data) {
    return this.request('diablo-im-message/diablo/getPersonMessage', Object.assign({},data,{
      filterSubtypeList: JSON.stringify([
        101,
        104,//问诊模版卡片
        200,
        2000,
        2001,
        3001,
        3003,
        3005
        //add new todo
      ]),
    }))
  }

  getChatOfflineMessageWithPerson(data) {
    return this.request('diablo-im-message/diablo/getChatOfflineMessageWithPerson', data)
  }

  /**
  * 获取医生详情
  * @param {long} doctorId 医生id
  */
   getDoctorInfo(doctorId) {
    return this.request('consultbrain/doctorApi/getDoctorInfo', { doctorId }).then((res) => {
      return res.result
    })
  }
  getUnreadInboxMsg(request) {
    return Promise.resolve({})
  }

  getWxRelation(request) {
    return this.request('consultbrain/userApi/getWxRelation', request)
  }

  /**
   * 上传主诉
   */
   uploadImEvent(requestParament) {
    return this.request('consultbrain/consultApi/uploadImEvent', requestParament).then((res) => {
      return res.result
    })
  }

  /**
   * 获取用户详细信息
   */
   getUserInfo() {
    return this.request('consultbrain/userApi/getUserInfo', {}).then((res) => {
      return res.result
    })
  }
}

export default new DiabloService()
